import {
  Overview as OverviewIcon,
  PreGrantees as PreGranteesIcon,
} from "../../Components/Icon";


import Overview from "../../Pages/PreGrant/Overview";
import PreGrantees from "../../Pages/PreGrant/PreGrantees";

const navigation = {
  header: "Pre Grant",
  links: [
    { text: "Overview", icon: OverviewIcon, route: "overview", component: Overview },
    {
      text: "Pre Grantees",
      icon: PreGranteesIcon,
      route: "pregrantees",
      component: PreGrantees,
    },
  ],
};
export default navigation;
